import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryFindInterface } from '@zaoblako/shared/common/dtos/history/history-find.dto';
import { DebtsExclusionService } from '@zaoblako/web/core/services/debts/debts-exclusion.service';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TimelineModule } from 'primeng/timeline';

@Component({
  selector: 'crm-exclusion-history',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonShowAndHideComponent,
    TimelineModule,
    UserAvatarComponent,
    SpinnerComponent,
    ProgressSpinnerModule,
    OrderByPipe
  ],
  templateUrl: './exclusion-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExclusionHistoryComponent {
  @Input() public readonly index: number;

  public exclusionHistoryInfo: {
    items: HistoryFindInterface[];
    queryParams: PaginationQueryInterface;
    paginationLoading: boolean;
    loading: boolean;
    count: number;
    showHistory: boolean;
  } = {
    items: [],
    queryParams: {
      limit: 100,
      offset: 0
    },
    paginationLoading: false,
    loading: true,
    count: 0,
    showHistory: false
  };

  public constructor(
    private readonly debtsExclusionService: DebtsExclusionService,
    private readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toHistory(item: any): HistoryFindInterface {
    return item as HistoryFindInterface;
  }

  public loadHistory(queryParams: PaginationQueryInterface) {
    this.exclusionHistoryInfo = {
      ...this.exclusionHistoryInfo,
      queryParams,
      loading: true
    };

    this.debtsExclusionService
      .getHistory(this.formStoreService.getState.forms[this.index]?.entityId, this.exclusionHistoryInfo.queryParams)
      .subscribe({
        next: (history) => {
          this.exclusionHistoryInfo = {
            ...this.exclusionHistoryInfo,
            items: history.items,
            count: history.count,
            loading: false
          };
          this.cdRef.markForCheck();
        }
      });
  }

  public onScrollEndHistory(target: HTMLElement): void {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (
        this.exclusionHistoryInfo?.items?.length < this.exclusionHistoryInfo?.count &&
        !this.exclusionHistoryInfo?.paginationLoading &&
        !this.exclusionHistoryInfo?.loading
      ) {
        this.exclusionHistoryInfo = {
          ...this.exclusionHistoryInfo,
          queryParams: {
            ...this.exclusionHistoryInfo.queryParams,
            offset: this.exclusionHistoryInfo.queryParams.offset + this.exclusionHistoryInfo.queryParams.limit
          },
          paginationLoading: true
        };

        this.debtsExclusionService
          .getHistory(this.formStoreService.getState.forms[this.index]?.entityId, this.exclusionHistoryInfo.queryParams)
          .subscribe({
            next: (history) => {
              this.exclusionHistoryInfo = {
                ...this.exclusionHistoryInfo,
                items: this.exclusionHistoryInfo.items.concat(history.items),
                count: history.count,
                paginationLoading: false
              };
              this.cdRef.markForCheck();
            }
          });
      }
    }
  }

  public isShowChange(isShow: boolean) {
    if (isShow) {
      this.loadHistory({
        ...this.exclusionHistoryInfo.queryParams,
        offset: 0
      });
    }
    this.exclusionHistoryInfo = {
      ...this.exclusionHistoryInfo,
      showHistory: !this.exclusionHistoryInfo.showHistory
    };
  }
}
